import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, Grid, List, ListItem, Collapse, styled } from "@mui/material";
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FetchVerbruikEstimate from "./FetchVerbruikEstimate";

/**
 * Return a box with one question: type of pand
 * Options:
 * ZZP
 * Eenmanszaak
 * Winkel
 * Kantoorpand
 * Industrieel
 * 
 * @param {*} param0 


/**
 * Return a box with one question: type of pand
 * Options:
 * ZZP
 * Eenmanszaak
 * Winkel
 * Kantoorpand
 * Industrieel
 * 
 * @param {*} param0 
 */

export default function ZakelijkVerbruikInschatterBox({
    selectedBuildingType,
    setSelectedBuildingType,
    setIsFetchingData,
    setVerbruikEstimaterStep2Output,
    agentID
}) {

    const CustomIcon = ({ iconClass }) => (
        <div className = "icon-text-wrapper">
        <div className={iconClass}></div>
        </div>
    );

    const FullWidthButton = styled(Button)(({ theme }) => ({
        width: 'calc(100% - ' + theme.spacing(2) + ')', // Trek de totale padding af van de breedte
        margin: theme.spacing(1), // Set een kleine margin voor elke kant
      }));
    
    useEffect(() => {
        if (selectedBuildingType) {
            handleBuildingTypeChange(selectedBuildingType);
        } else {
            setSelectedBuildingType('ZZP');
        }

        if (selectedBuildingType) {
            const fetchData = async () => {
                try {        
                    // Fetch de schatting en sla op in results
                    const results = await FetchVerbruikEstimate({
                        householdSize: 0,
                        selectedBuildingType: selectedBuildingType.toLowerCase(),
                        entity: 'Zakelijk',
                        setIsFetchingData,
                        agentID
                    });
        
                    // Doe iets met de results hier, bijvoorbeeld de staat bijwerken
                    setVerbruikEstimaterStep2Output(results);
                    
                } catch (error) {
                    // Als er een fout optreedt tijdens het ophalen, log deze dan
                    console.error("Er is een fout opgetreden bij het ophalen van de zakelijke verbruiksschatting:", error);
                }
            };
        
            fetchData();
        }


    }, [selectedBuildingType]);

    const handleBuildingTypeChange = (type) => {
        setSelectedBuildingType(type);
    };

    const mapTypeToIconName = (type) => {
        switch (type) {
            case 'ZZP':
                return 'zzp';
            case 'Eenmanszaak':
                return 'eenmanszaak';
            case 'Winkel':
                return 'winkel';
            case 'Kantoorpand':
                return 'kantoor';
            case 'Industrieel':
                return 'industrie';
        }
    };

    

    return (
        <Box>
            <Typography variant="h6">
                Wat voor soort pand betreft het?
            </Typography>

            <List>
                {['ZZP', 'Eenmanszaak', 'Winkel', 'Kantoorpand', 'Industrieel'].map((type) => (
                    <ListItem key={type}>
                        <FullWidthButton
                            startIcon={<CustomIcon iconClass={`icon-as-${mapTypeToIconName(type)} icon-size`} />}
                            variant={selectedBuildingType === type ? "contained" : "outlined"}
                            onClick={() => handleBuildingTypeChange(type)} // Geef het type mee wanneer de knop wordt aangeklikt.
                        >
                            {type}
                        </FullWidthButton>

                    </ListItem>
                ))}
            </List>
        </Box>
    );
}